import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomescreenComponent } from './agatextscreens/homescreen/homescreen.component';
import { PurchasingProductsListComponent } from './agatextscreens/purchasing/products/products-list/purchasing-products-list.component';
import { CollectionsListComponent } from './agatextscreens/purchasing/collections-list/collections-list.component';
import { DesignsListComponent } from './agatextscreens/purchasing/designs-list/designs-list.component';
import { LoginComponent } from './agatextscreens/login/login.component';
import { HomepageComponent } from './agatextscreens/homepage/homepage.component';
import { PurchasingProductComponent } from './agatextscreens/purchasing/products/product/purchasing-product.component';
import { SuppliersListComponent } from './agatextscreens/purchasing/suppliers/suppliers-list/suppliers-list.component';
import { SuppliersSaveComponent } from './agatextscreens/purchasing/suppliers/suppliers-save/suppliers-save.component';
import { PoListComponent } from './agatextscreens/purchasing/pos/po-list/po-list.component';
import { PoNewComponent } from './agatextscreens/purchasing/pos/po-new/po-new.component';
import { PoBranchToBranchComponent } from './agatextscreens/purchasing/po-branch-to-branch/po-branch-to-branch.component';
import { ReceivingListComponent } from './agatextscreens/receiving/receiving-list/receiving-list.component';
import { ReceivingEditComponent } from './agatextscreens/receiving/receiving-edit/receiving-edit.component';
import { InventoryListComponent } from './agatextscreens/inventory/inventory-list/inventory-list.component';
import { InventoryPieceComponent } from './agatextscreens/inventory/inventory-piece/inventory-piece.component';
import { InventoryPiecesComponent } from './agatextscreens/inventory/inventory-pieces/inventory-pieces.component';
import { SalesListComponent } from './agatextscreens/sales/sales-list/sales-list.component';
import { SalesNewComponent } from './agatextscreens/sales/sales-new/sales-new.component';
import { UserListComponent } from './agatextscreens/admin/user-list/user-list.component';
import { AuthenticationGuard } from './shared/guards/authentication.guard';
import { BranchesListComponent } from './agatextscreens/accounting/branches/branches-list/branches-list.component';
import { BranchesSaveComponent } from './agatextscreens/accounting/branches/branches-save/branches-save.component';
import { CustomerListComponent } from './agatextscreens/accounting/customer/customer-list/customer-list.component';
import { CustomerComponent } from './agatextscreens/accounting/customer/customer/customer.component';
import { PdaInventoryComponent } from './agatextscreens/pda/inventory/pda-inventory.component';
import { PdaInvMainComponent } from './agatextscreens/pda/inventory/main/pda-inv-main.component';
import { InvChangeLocationComponent } from './agatextscreens/pda/inventory/change-pallet/change-pallet.component';
import { InvFindProductComponent } from './agatextscreens/pda/inventory/find-product/find-product.component';
import { InvFindItemComponent } from './agatextscreens/pda/inventory/find-item/find-item.component';
import { InvListItemsComponent } from './agatextscreens/pda/inventory/list-items/list-items.component';
import { InvCutItemComponent } from './agatextscreens/pda/inventory/cut-item/cut-item.component';
import { PdaShippingMainComponent } from './agatextscreens/pda/shipping/main/pda-shipping-main.component';
import { PdaShippingComponent } from './agatextscreens/pda/shipping/pda-shipping.component';
import { ShipOrderComponent } from './agatextscreens/pda/shipping/ship-order/ship-order.component';
import { PrepareOrderComponent } from './agatextscreens/pda/shipping/prepare-order/prepare-order.component';
import { CheckOrderComponent } from './agatextscreens/pda/shipping/check-order/check-order.component';
import { PdaReceivingMainComponent } from './agatextscreens/pda/receiving/main/pda-receiving-main.component';
import { PdaReceivingComponent } from './agatextscreens/pda/receiving/pda-receiving.component';
import { PrintLabelsComponent } from './agatextscreens/pda/receiving/print-labels/print-labels.component';
import { ScanComponent } from './agatextscreens/pda/receiving/scan/scan.component';
import { ScanPiecesComponent } from './agatextscreens/pda/receiving/scan/scan-pieces/scan-pieces.component';
// import { TransferComponent } from './agatextscreens/pda/receiving/transfer/transfer.component';
import { UnitPriceComponent } from './agatextscreens/admin/unit-price/unit-price.component';
import { CityCountryComponent } from './agatextscreens/admin/city-country/city-country.component';
import { PrintLocationLabelComponent } from './agatextscreens/pda/inventory/print-location-label/print-location-label.component';
import { PrintProductLabelComponent } from './agatextscreens/pda/inventory/print-product-label/print-product-label.component';
import { PrintRollLabelComponent } from './agatextscreens/pda/inventory/print-roll-label/print-roll-label.component';
import { PageNotFoundComponent } from './agatextscreens/page-not-found/page-not-found.component';
import { UserNewComponent } from './agatextscreens/admin/user-new/user-new.component';
import { OptionsComponent } from './agatextscreens/admin/options/options.component';
import { PrepareOrderItemsComponent } from './agatextscreens/pda/shipping/prepare-order-items/prepare-order-items.component';
import { ShipOrderItemsComponent } from './agatextscreens/pda/shipping/ship-order-items/ship-order-items.component';
import { LocationComponent } from './agatextscreens/admin/location/location.component';
import { BackorderListComponent } from './agatextscreens/sales/backorder-list/backorder-list.component';
import { BackorderComponent } from './agatextscreens/sales/backorder/backorder.component';
import { RefundComponent } from './agatextscreens/sales/refund/refund.component';
import { RefundListComponent } from './agatextscreens/sales/refund-list/refund-list.component';
import { InvoiceListComponent } from './agatextscreens/accounting/invoice-list/invoice-list.component';
import { ChequesListComponent } from './agatextscreens/accounting/cheques-list/cheques-list.component';
import { AccountListComponent } from './agatextscreens/accounting/account-list/account-list.component';
import { AccountComponent } from './agatextscreens/accounting/account/account.component';
import { AccountLedgerComponent } from './agatextscreens/accounting/account-ledger/account-ledger.component';
import { AccountDepositComponent } from './agatextscreens/accounting/account-deposit/account-deposit.component';
import { AccountWithdrawalComponent } from './agatextscreens/accounting/account-withdrawal/account-withdrawal.component';
import { AccountTransferComponent } from './agatextscreens/accounting/account-transfer/account-transfer.component';
import { PaymentComponent } from './agatextscreens/accounting/payment/payment.component';
import { ReturnComponent } from './agatextscreens/pda/receiving/returns/returns.component';
import { ReturnPiecesComponent } from './agatextscreens/pda/receiving/returns/return-pieces/return-pieces.component';
import { ImportComponent } from './agatextscreens/pda/import/import.component';
import { DebitNoteListComponent } from './agatextscreens/sales/debit-note-list/debit-note-list.component';
import { DebitNoteComponent } from './agatextscreens/sales/debit-note/debit-note.component';
import { CatalogListComponent } from './agatextscreens/purchasing/catalogs/catalog-list/catalog-list.component';
import { CatalogComponent } from './agatextscreens/purchasing/catalogs/catalog/catalog.component';
import { SalesForcastingComponent } from './agatextscreens/sales/sales-forcasting/sales-forcasting.component';
import { FabrictypelistComponent } from './agatextscreens/purchasing/fabrictypes/fabrictypelist/fabrictypelist.component';
import { FabrictypeComponent } from './agatextscreens/purchasing/fabrictypes/fabrictype/fabrictype.component';
import { PalletListComponent } from './agatextscreens/accounting/pallets/pallet-list/pallet-list.component';
import { PalletComponent } from './agatextscreens/accounting/pallets/pallet/pallet.component';
import { GradesComponent } from './agatextscreens/accounting/grades/grades.component';

const routes: Routes = [
    {
        path: '',
        component: HomepageComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/products',
        component: PurchasingProductsListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/catalogs',
        component: CatalogListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/catalogs/new',
        component: CatalogComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/catalogs/edit/:id',
        component: CatalogComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/designs',
        component: DesignsListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/collections',
        component: CollectionsListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'purchasing/products/new',
        component: PurchasingProductComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/products/edit/:id',
        component: PurchasingProductComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/fabrictypes',
        component: FabrictypelistComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/fabrictypes/new',
        component: FabrictypeComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/fabrictypes/edit/:id',
        component: FabrictypeComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/suppliers',
        component: SuppliersListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/suppliers/new',
        component: SuppliersSaveComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/suppliers/edit/:id',
        component: SuppliersSaveComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/po',
        component: PoListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/po/new',
        component: PoNewComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/branchtransfer/new',
        component: PoBranchToBranchComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/po/edit/:id',
        component: PoNewComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'purchasing/branchtransfer/edit/:id',
        component: PoBranchToBranchComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'receiving/list',
        component: ReceivingListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'receiving/edit/:recNumber',
        component: ReceivingEditComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'inventory/list',
        component: InventoryListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'inventory/list/pieces/:branch_id/:color_id',
        component: InventoryPiecesComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'inventory/list/piece/:id',
        component: InventoryPieceComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'inventory/list/piece',
        component: InventoryPieceComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'sales/list',
        component: SalesListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'sales/forcasting',
        component: SalesForcastingComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'sales/edit/:id',
        component: SalesNewComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'sales/new',
        component: SalesNewComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'debitnotes/list',
        component: DebitNoteListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'debitnotes/edit/:id',
        component: DebitNoteComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'debitnotes/new',
        component: DebitNoteComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'refunds/list',
        component: RefundListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'refunds/edit/:id',
        component: RefundComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'refunds/new',
        component: RefundComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'backorder/list',
        component: BackorderListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'backorder/edit/:id',
        component: BackorderComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'backorder/new',
        component: BackorderComponent,
        canActivate: [AuthenticationGuard]
    }, {
        path: 'admin/users/list',
        component: UserListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'user/edit/:id',
        component: UserNewComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'admin/unit-prices',
        component: UnitPriceComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'admin/cities',
        component: CityCountryComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'admin/options',
        component: OptionsComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/locations',
        component: LocationComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/branches',
        component: BranchesListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/branches/new',
        component: BranchesSaveComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/branches/edit/:id',
        component: BranchesSaveComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/customers',
        component: CustomerListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/customers/new',
        component: CustomerComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/customers/edit/:id',
        component: CustomerComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/invoices',
        component: InvoiceListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/invoices/settle/:id',
        component: PaymentComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/cheques',
        component: ChequesListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/bank',
        component: AccountListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/bank/:id',
        component: AccountComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/bank/ledger/:id',
        component: AccountLedgerComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/deposit/:id',
        component: AccountDepositComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/withdrawal/:id',
        component: AccountWithdrawalComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/transfer/:id',
        component: AccountTransferComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/grades',
        component: GradesComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/pallets',
        component: PalletListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/pallets/new',
        component: PalletComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'accounting/pallets/edit/:id',
        component: PalletComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'pda/pallets',
        component: PalletListComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'pda/pallets/new',
        component: PalletComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'pda/pallets/edit/:id',
        component: PalletComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'pda/import',
        component: ImportComponent,
        canActivate: [AuthenticationGuard]
    },
    {
        path: 'pda/receiving',
        component: PdaReceivingComponent,
        canActivate: [AuthenticationGuard],
        children: [
            {
                path: '',
                component: PdaReceivingMainComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'scan',
                component: ScanComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'scan/pieces/:recv_id',
                component: ScanPiecesComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'return',
                component: ReturnComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'return/pieces/:return_id',
                component: ReturnPiecesComponent,
                canActivate: [AuthenticationGuard]
            },
            // {
            //     path: 'transfer',
            //     component: TransferComponent,
            //     canActivate: [AuthenticationGuard]
            // },
            {
                path: 'printlabels',
                component: PrintLabelsComponent,
                canActivate: [AuthenticationGuard]
            }
        ]
    },
    {
        path: 'pda/inventory',
        component: PdaInventoryComponent,
        canActivate: [AuthenticationGuard],
        children: [
            {
                path: '',
                component: PdaInvMainComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'changeLocation',
                component: InvChangeLocationComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'findProduct',
                component: InvFindProductComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'findItem',
                component: InvFindItemComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'listItems',
                component: InvListItemsComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'cutItem',
                component: InvCutItemComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'printRollLabel',
                component: PrintRollLabelComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'printProductLabel',
                component: PrintProductLabelComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'printLocationLabel',
                component: PrintLocationLabelComponent,
                canActivate: [AuthenticationGuard]
            }
        ]
    },
    {
        path: 'pda/shipping',
        component: PdaShippingComponent,
        canActivate: [AuthenticationGuard],
        children: [
            {
                path: '',
                component: PdaShippingMainComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'shipOrder',
                component: ShipOrderComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'shipOrderItems/:id',
                component: ShipOrderItemsComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'prepareOrder',
                component: PrepareOrderComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'prepareOrderItems/:id',
                component: PrepareOrderItemsComponent,
                canActivate: [AuthenticationGuard]
            },
            {
                path: 'checkOrder',
                component: CheckOrderComponent,
                canActivate: [AuthenticationGuard]
            }
        ]
    },

    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        canActivate: [AuthenticationGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { useHash: true }),
    ],
    exports: [
        RouterModule,
    ],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/app-routing.module.ts